/**
 * mutates the applicant.serviceTypes.data property with the data given and
 * sets the applicant.serviceTypes.retrieved = true
 */
export const getServiceTypes = (state, data) => {
  state.applicant.serviceTypes.data = data;
  state.applicant.serviceTypes.retrieved = true;
};
